import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { LoginContext } from '../../Contexts/LoginContext';
import { PiUserSwitchFill } from "react-icons/pi";
import { FaShop } from "react-icons/fa6";
import SellerImage from "../../images/pngs/seller.png";
import { formatCityCountry } from "../utils/formatAddress";

export default function ProfileDrawer({ isSeller, sellerOrderUnread = 0 }) {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);
  const iconRef = useRef(null);
  const { logout, user } = useContext(LoginContext);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);



  return (
    <div className="profileDrawerContainer">
      {/* Profile Icon or Image */}
      <div ref={iconRef} onClick={toggleDrawer} style={{ cursor: 'pointer', position: 'relative' }}>
        {user?.role === "seller" && user?.sellerId?.profileImage ? (
          <img src={user.sellerId.profileImage} alt="Profile" className="headerProfileImg" />
        ) : (
          <FaUserCircle className="profileIcon" />
        )}
        {!isSeller && sellerOrderUnread > 0 && (
          <span className="profileBadge">{sellerOrderUnread > 9 ? '9+' : sellerOrderUnread}</span>
        )}
      </div>

      {isOpen && (
        <div className="drawerContainer" ref={popupRef}>
          <div className="drawer">
            <div className="triangle"></div>

            <div className="drawerHeader">
              <img
                src={user?.role === "seller" ? user?.sellerId?.profileImage : SellerImage}
                alt="Shahab Hassan"
                className="profileImage"
              />
              <div className="profileDetails">
                <p className="profileName">{user?.role === "seller" ? user?.sellerId?.displayName : user?.fullName || user?.username}</p>
                {user?.buyerAddress && (
                  <p className="profileLocation">{formatCityCountry(user.buyerAddress)}</p>
                )}
              </div>
            </div>
            <div className="drawerMenu">
              <Link
                onClick={toggleDrawer}
                to={isSeller ? "/seller/settings" : "/settings"}
                state={isSeller ? { isSellerAccount: true } : { isSellerAccount: false }}
              >
                Settings
              </Link>
              {(!isSeller || user?.role === 'buyer') && (
                <Link onClick={toggleDrawer} to="/account/credits">Account credits</Link>
              )}
              <Link onClick={toggleDrawer} to={`${isSeller ? "/seller/contact" : "/contact"}`}>Contact Us</Link>
              <Link onClick={toggleDrawer} to={`${isSeller ? "/seller/myReviews" : "/myReviews"}`}>{isSeller ? 'Ratings & feedback' : 'My reviews'}</Link>
              <Link onClick={() => { toggleDrawer(); logout() }} style={{ color: "red" }}>Logout</Link>

              {(user?.role === "seller" && user?.sellerId) ? <Link onClick={toggleDrawer} to={isSeller ? '/' : '/sellerDashboard'} className="switchToSelling">
                <PiUserSwitchFill className='icon' />
                {isSeller ? 'Switch to Buying' : 'Switch to Selling'}
                {!isSeller && sellerOrderUnread > 0 && (
                  <span className="switchSellerUnreadBadge">{sellerOrderUnread}</span>
                )}
              </Link> : <Link onClick={toggleDrawer} to={'/becomeSeller'} className="switchToSelling">
                <FaShop className='icon' />
                Become a Seller
              </Link>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}